import { sparketLightGray } from "utils/constants.ts";

const OrSeparator = () => {
  return (
    <div className="d-flex align-items-center" style={{ margin: "24px 0" }}>
      <div 
        style={{ 
          flex: 1, 
          height: '1px', 
          background: `linear-gradient(to right, transparent, ${sparketLightGray}, transparent)`,
          opacity: 0.3
        }}
      />
      <div
        style={{
          color: sparketLightGray,
          padding: '0 20px',
          fontSize: '12px',
          fontWeight: '500',
          letterSpacing: '0.5px',
          textTransform: 'uppercase',
          opacity: 0.7
        }}
      >
        OR
      </div>
      <div 
        style={{ 
          flex: 1, 
          height: '1px', 
          background: `linear-gradient(to left, transparent, ${sparketLightGray}, transparent)`,
          opacity: 0.3
        }}
      />
    </div>
  );
};

export default OrSeparator; 